export default __webpack_public_path__ + "static/media/Group 11870.8f6bbf01.svg";